// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2be5da8a] .md-dialog-container{overflow:visible}[data-v-2be5da8a] .comment-card{margin-top:0;box-shadow:none}[data-v-2be5da8a] .comment-card .table-container{max-height:400px}", ""]);
// Exports
module.exports = exports;
